import React from 'react';
import PropTypes from 'prop-types';

import { trans, getPagePath } from '@spotahome/soyuz/client';

import { CookiesBanner } from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/CookiesBanner.css';

const COOKIES_ROUTE_ID = 'externals.cookies-policy';
const COOKIES_MESSAGE = 'landingpage.label.cookies_improve_experience';

const Cookies = props => (
  <CookiesBanner
    acceptOnClick
    className="cookies-banner"
    link={getPagePath(COOKIES_ROUTE_ID)}
    message={trans(COOKIES_MESSAGE)}
    scrollSettings={props.scrollSettings}
  />
);

const scrollSettingsShape = {
  elementId: PropTypes.string,
  enabled: PropTypes.bool,
  seconds: PropTypes.number
};

Cookies.propTypes = {
  scrollSettings: PropTypes.shape(scrollSettingsShape)
};

Cookies.defaultProps = {
  scrollSettings: {
    enabled: true
  }
};

export default Cookies;
